
export default {
    name: "Share",
    props:{
        /**
         * Name of the network to display.
         */
        network: {
            type: String,
            required: true
        },

        /**
         * URL of the content to share.
         */
        url: {
            type: String,
            required: true
        },

        /**
         * Title of the content to share.
         */
        title: {
            type: String,
            default: ''
        },

        /**
         * Description of the content to share.
         */
        description: {
            type: String,
            default: ''
        },

        /**
         * Quote content, used for Facebook.
         */
        quote: {
            type: String,
            default: ''
        },

        /**
         * Hashtags, used for Twitter and Facebook.
         */
        hashtags: {
            type: String,
            default: ''
        },

        /**
         * Twitter user, used for Twitter
         * @var string
         */
        twitterUser: {
            type: String,
            default: ''
        },

        /**
         * Media to share, used for Pinterest
         */
        media: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            networks: {
                facebook: 'https://www.facebook.com/sharer/sharer.php?u=@u&title=@t&description=@d&quote=@q&hashtag=@h',
                linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=@u',
                telegram: 'https://t.me/share/url?url=@u&text=@t%0D%0A@d',
                twitter: 'https://twitter.com/intent/tweet?text=@t&url=@u&hashtags=@h@tu',
                whatsapp: 'https://api.whatsapp.com/send?text=@t%0D%0A@u%0D%0A@d',
            }
        }
    },
    computed: {
        /**
         * Formatted network name.
         */
        key () {
            return this.network.toLowerCase()
        },

        /**
         * Network sharing raw sharing link.
         */
        rawLink () {
            const ua = navigator.userAgent.toLowerCase()

            /**
             * On IOS, SMS sharing link need a special formatting
             * Source: https://weblog.west-wind.com/posts/2013/Oct/09/Prefilling-an-SMS-on-Mobile-Devices-with-the-sms-Uri-Scheme#Body-only
             */
            if (this.key === 'sms' && (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1)) {
                return this.networks[this.key].replace(':?', ':&')
            }

            return this.networks[this.key]
        },

        /**
         * Create the url for sharing.
         */
        shareLink () {
            let link = this.rawLink

            /**
             * Twitter sharing shouldn't include empty parameter
             * Source: https://github.com/nicolasbeauvais/vue-social-sharing/issues/143
             */
            if (this.key === 'twitter') {
                if (!this.hashtags.length) link = link.replace('&hashtags=@h', '')
                if (!this.twitterUser.length) link = link.replace('@tu', '')
            }

            return link
                .replace(/@tu/g, '&via=' + encodeURIComponent(this.twitterUser))
                .replace(/@u/g, encodeURIComponent(this.url))
                .replace(/@t/g, encodeURIComponent(this.title))
                .replace(/@d/g, encodeURIComponent(this.description))
                .replace(/@q/g, encodeURIComponent(this.quote))
                .replace(/@h/g, this.encodedHashtags)
                .replace(/@m/g, encodeURIComponent(this.media))
        },

        /**
         * Encoded hashtags for the current social network.
         */
        encodedHashtags () {
            if (this.key === 'facebook' && this.hashtags.length) {
                return '%23' + this.hashtags.split(',')[0]
            }

            return this.hashtags
        }
    }
}
